import React from 'react';
import { observer } from 'mobx-react';
import AuthComponent from './Auth.component';
import useAuth from './useAuth';

const Container: React.FC = () => {
    const { lang, app, modal, handlers } = useAuth();

    return (
        <>
            <AuthComponent
                lang={lang.lang}
                cookies={!app.cookiesApproved}
                authenticationVisible={modal.window === 'authentication'}
                registerVisible={modal.window === 'register'}
                passRecoveryVisible={modal.window === 'passwordRecovery'}
                onAuthenticationOpen={handlers.handleAuthenticationOpen}
                onAuthenticationClose={handlers.handleAuthenticationClose}
                onDemoClick={handlers.handleDemoClick}
                onBtnKeyDown={handlers.handleBtnKeyDown}
            />
        </>
    );
};

const AuthContainer = observer(Container);

export default AuthContainer;
